import { render, staticRenderFns } from "./TranCodeEditor.vue?vue&type=template&id=95aecee8&scoped=true"
import script from "./TranCodeEditor.vue?vue&type=script&lang=js"
export * from "./TranCodeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aecee8",
  null
  
)

export default component.exports